import React, {useEffect, useState} from "react";

// MUI
import IconButton from "@mui/material/IconButton";
import {Box, Slide,Fade} from "@mui/material"

// MUI Icons
import AddIcon from "@mui/icons-material/Add";

// OL
import OlFeature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";

// Custom
import RouteAddIcon from "@/icons/RouteAddIcon";
import { prepareCoordinatesForDisplay } from "@/lib/olHelpers";
import { CardPosition } from "@/@types/views/GIS/map";

interface PointQuickActionsProps {
  feature?: OlFeature<Geometry>;
  onAddToRoute: (coord: number[] | undefined, label: string, poi_id?: number) => void;
  coords?: number[];
  position?:CardPosition;
  slide: boolean;
}

function PointQuickActions(props: PointQuickActionsProps) {
  const { feature, onAddToRoute, coords,position,slide }= props;

  const [animate, setAnimate] = useState<boolean>(false);
  const [hovered, setHovered] = useState<boolean>(false);
  
  const coordinates = coords ? coords : (feature?.getGeometry() as Point).getCoordinates() as number[]; //EPSG:3857
  const displayCoordinates = prepareCoordinatesForDisplay(coordinates);

  useEffect(() => {
    setAnimate(false);
    
    const timeoutId = setTimeout(() => {
      setAnimate(true);
    }, 1);

    return () => {
      clearTimeout(timeoutId); // Unmount memory leak safety
    };
  }, [position]);

  const containerRef = React.useRef<HTMLElement>(null);

  const handleAddToRoute = () => {
    const dmsCoordinates = `${displayCoordinates[1]}N ${displayCoordinates[0]}E`;
    
    if (feature) {
      const naziv = feature.get("naziv");
      const poi_id = feature.get("poi_id")
      const geom = feature.getGeometry();
      if (geom) {
        onAddToRoute(coordinates, naziv ? naziv : dmsCoordinates, poi_id ?? undefined);
      }
    } else {
      onAddToRoute(coordinates, dmsCoordinates);
    }
   }
  return (
    <Box ref={containerRef}>
      {slide ? 
        <Slide timeout={300} direction="right" in={animate} container={containerRef.current}>
          <Box>
            <Fade timeout={300} in={animate} >
              <IconButton 
                disableFocusRipple 
                disableRipple
                disableTouchRipple
                onClick={handleAddToRoute} 
                size="small"
                onMouseOver={()=>{
                  setHovered(true);
                }}
                onMouseOut={()=>{
                  setHovered(false);
                }}
              >
                <RouteAddIcon   sx={{
                  transition: "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform .2s;"
                }} 
                transform={hovered?"scale(1.47)":"scale(1.23)"}
              />
              </IconButton>
            </Fade>
          </Box>
        </Slide>
        : 
        <Fade timeout={300} in={animate} >
          <IconButton 
            disableFocusRipple 
            disableRipple
            disableTouchRipple
            onClick={handleAddToRoute} 
            size="small"
            onMouseOver={()=>{
              setHovered(true);
            }}
            onMouseOut={()=>{
              setHovered(false);
            }}
            >
              <RouteAddIcon   sx={{
                  transition: "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform .2s;"
                }} 
                transform={hovered?"scale(1.5)":"scale(1.25)"}
              />
          </IconButton>
        </Fade>
      }
    </Box>
  );
}

export default PointQuickActions;
